import { render, staticRenderFns } from "./Agendas.vue?vue&type=template&id=06be52fe"
import script from "./Agendas.vue?vue&type=script&lang=js"
export * from "./Agendas.vue?vue&type=script&lang=js"
import style0 from "./Agendas.vue?vue&type=style&index=0&id=06be52fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports